import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import './MarketCategoryThirtyDaysVolumeModal.scss';

import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, LinearProgress
} from '@material-ui/core';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, LabelList } from 'recharts';
import { Percentual, NumberLessBRL } from 'src/services';
import { QueryFilter, QUERY_FILTER_MARKET } from 'src/component/shared';
// import withStyles from '@material-ui/core/styles/withStyles';

export interface IMarketCategoryThirtyDaysVolumeModalEntity {
  id: number;
  group: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoryThirtyDaysVolumeModalProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoryThirtyDaysVolumeModalState {
  isUpdate: boolean,
  dialogOpen: boolean,
    customFilter: {
        isChart: boolean
    },
}

export interface IMarketCategoryThirtyDaysVolumeDataChart {
  subject: string;
  percent_label: string;
  percent_result: number;
  volume: string;
}

const MARKET_SUBJECT_SHARE = gql`
query marketCategoryThirtyDaysVolume($customFilter:  MarketShareCustomFilter) {
  marketCategoryThirtyDaysVolume(marketShareCustomFilter: $customFilter) {
    subject,
    percent_label,
    volume,
  }
}
`;

// statless component
const MarketCategoryThirtyDaysVolumeTooltipData = (props: any) => {

  let content;
  props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

  return (<div className="tooltip-box">
      <table>
          <tbody>
              <tr className="tooltip-text">
                  <td className="tooltip-title">Assunto:</td><td className="tooltip-content">{content && content.subject}</td>
              </tr>
              <tr className="tooltip-text">
                  <td className="tooltip-title">Share:</td><td className="tooltip-content">{content && content.percent_label}</td>
              </tr>
              <tr className="tooltip-text">
                  <td className="tooltip-title">Volume:</td><td className="tooltip-content">{content && content.volume}</td>
              </tr>
          </tbody>
      </table>
  </div>
  )
};
// statless component
const MarketCategoryThirtyDaysVolumeDataChart = ({ data }: { data: IMarketCategoryThirtyDaysVolumeDataChart[] }) => (

  <ResponsiveContainer width="100%" height={600} >
    <BarChart
      data={data}
      margin={{ top: 5, right: 30, left: 20, bottom: 150 }}>
      <CartesianGrid vertical={false} horizontal={false} />
      <XAxis dataKey="subject" tickMargin={5} tick={{ angle: 45, fontSize: 15, textAnchor:'start' }} interval={0} />
      <YAxis yAxisId="center" hide={true} />
      <Tooltip content={<MarketCategoryThirtyDaysVolumeTooltipData />} />
      <Bar yAxisId="center" dataKey="percent_result" fill="#65cc93" barSize={20} >
        <LabelList dataKey="percent_label" position="top" angle={-30} className="recharts-label-custom-black" />
      </Bar>
    </BarChart>
  </ResponsiveContainer>

);

export class MarketCategoryThirtyDaysVolumeModal extends React.Component<IMarketCategoryThirtyDaysVolumeModalProps, IMarketCategoryThirtyDaysVolumeModalState> {
    constructor(props: IMarketCategoryThirtyDaysVolumeModalProps) {
      super(props);
      this.state = {
        customFilter: {
          isChart: true,
        },
        dialogOpen: false,
        isUpdate: false,
  }
}

public render() {
    const jsonFilter = {
        "customFilter": {
            "isChart": this.state.customFilter.isChart,
        }
    };

    return (
      <Query query={QUERY_FILTER_MARKET} notifyOnNetworkStatusChange={true}  >
        {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
            return (
              <Query query={MARKET_SUBJECT_SHARE} variables={QueryFilter.getFilterMarket(clientC, jsonFilter, ['category'], false)}>
                {({ loading, error, data, client }) => {
                  return this.dataToRend(data,loading);
                }}
              </Query>
            );
            
        }}
      </Query>
    )
  }

  /**
   * Método utilizado para renderizar as informações do card
   * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
   */
  private dataToRend (data:any, loading:any) {
    return (
      <div className="filter-item">
        <Button onClick={this.handleDialogOpen} color="primary">
          Ver Mais
        </Button>
        <Dialog
          fullScreen={true}
          open={this.state.dialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="economic-group-dialog-title"
          aria-describedby="alereconomic-group-dialog-description"
          className="filter-dialog">
          <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">{"Share por Categoria (BISAC)"}</DialogTitle>
          <DialogContent className="filter-dialog-content">
            <Paper className="publisher-sale-block panel-block" >
              {loading && <LinearProgress />}
              {data.marketCategoryThirtyDaysVolume && (<MarketCategoryThirtyDaysVolumeDataChart data={this.MarketCategoryThirtyDaysVolumeDataChartMap(data.marketCategoryThirtyDaysVolume)} />)}
            </Paper>
          </DialogContent>
          <DialogActions className="filter-actions">
            <Button className="filter-dialog-close" onClick={this.handleDialogClose} >
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  private MarketCategoryThirtyDaysVolumeDataChartMap = (data: IMarketCategoryThirtyDaysVolumeDataChart[]) => {

    const mappedData: IMarketCategoryThirtyDaysVolumeDataChart[] = [];

    data.forEach(e => {

      const item: IMarketCategoryThirtyDaysVolumeDataChart = {
        percent_label: Percentual(e.percent_label.toString()),
        percent_result: Number(e.percent_label),
        subject: e.subject === null || e.subject === undefined ? 'Outros' : e.subject,
        volume: NumberLessBRL(e.volume.toString()),
      };
      mappedData.push(item);

    });

    return mappedData;
  }

  private handleDialogOpen = () => {
    this.setState({ dialogOpen: true });
  };

  private handleDialogClose = () => {
    this.setState({ dialogOpen: false });
  };

}



// WEBPACK FOOTER //
// ./src/component/market/general/categories/thirty-days/volume/modal/MarketCategoryThirtyDaysVolumeModal.tsx